// pattern: Imperative Shell

import { html } from 'htm/preact'
import { type FunctionComponent, render } from 'preact'
import { useComputed, useSignalEffect } from '@preact/signals'
import Debug from '@substrate-system/debug'
import { State } from './state.js'
import Router, { routes, titleForRoute } from './routes/index.js'
import './style.css'

const router = Router()
const state = State()
const debug = Debug('eoapi')

// set debug logging in local env
if (isDev()) {
    localStorage.setItem('DEBUG', 'eoapi:*,eoapi')
    // @ts-expect-error DEV env
    window.state = state
} else {
    localStorage.removeItem('DEBUG')
    localStorage.removeItem('debug')
}

export const Example:FunctionComponent = function Example () {
    debug('rendering example...', state)

    useSignalEffect(() => {
        document.title = titleForRoute(state.route.value)
    })

    const match = useComputed(() => {
        return router.match(state.route.value)
    })

    if (!match.value || !match.value.action) {
        return html`<div class="not-found">
            <h1>404</h1>
        </div>`
    }

    const ChildNode = match.value.action(match.value, state.route.value)

    return html`
        <header>
            <h1><a href="/">Easy OpenAPI</a></h1>

            <${Nav} route=${state.route.value} />
        </header>
        <main>
            <${ChildNode} state=${state} />
        </main>
    `
}

render(html`<${Example} />`, document.getElementById('root')!)

function isDev ():boolean {
    return !!(import.meta.env.DEV || import.meta.env.MODE === 'staging')
}

function Nav ({ route }:{ route:string }):ReturnType<typeof html> {
    return html`<nav aria-label="Main navigation">
        <ul>
            ${routes.map(r => {
                return html`<li class="nav${route === r.href ? ' active' : ''}">
                    <a href="${r.href}">${r.text}</a>
                </li>`
            })}
        </ul>
    </nav>`
}
